<style src="css/help.css" scoped></style>
<template>
  <div
    style="
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top:.26rem;
    "
  >
    <!-- <newsTopBox title="心理评测"></newsTopBox> -->
    <div class="inputBigBox">
        <div class="bigTitle">申请人信息</div>
        <div class="inputBox">
            <div class="titleBox">申请人姓名<span>*</span></div>
            <input type="text" v-model="name" placeholder="请输入">
        </div>
        <div class="inputBox">
            <div class="titleBox">性别<span>*</span></div>
            <div class="valueBox">
                <div class="flex" @click="changeGender(0)">
                    <div class="select" :class="{'active':gender==0}"></div>男
                </div>
                <div class="flex" style="margin-left:.6rem"  @click="changeGender(1)">
                    <div :class="{'active':gender==1}" class="select"></div>女
                </div>
            </div>
        </div>
        <div class="inputBox">
            <div class="titleBox">申请人手机号<span>*</span></div>
            <input type="text" v-model="mobile" placeholder="请输入">
        </div>
        <div class="inputBox">
            <div class="titleBox">申请人现居地址<span>*</span></div>
            <input type="text" v-model="nowLive" placeholder="请输入">
        </div>
        <div class="inputBox" v-if="coopType==0">
            <div class="titleBox">申请人所属所<span>*</span></div>
            <input type="text" v-model="policeStation" placeholder="请输入">
        </div>
        <div class="inputBox">
            <div class="titleBox">申请人身份证号码<span>*</span></div>
            <input type="text" v-model="idCard" placeholder="请输入">
        </div>
        <div class="inputBox" v-if="coopType==1">
            <div class="titleBox">培训内容<span>*</span></div>
            <input type="text" v-model="trainingContent" placeholder="请输入">
        </div>
        <div class="inputBox"  v-if="coopType==1">
            <div class="titleBox">培训岗位<span>*</span></div>
            <input type="text" v-model="trainingPosts" placeholder="请输入">
        </div>
        <div class="inputBox">
            <div class="titleBox">申请理由<span>*</span></div>
            <textarea placeholder="请输入" v-model="reason"></textarea>
        </div>
    </div>
    <div class="btnBox">
        <div class="btn active" @click="save">提交</div>
    </div>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";

import noMoreData from "components/no-more-data";
import newsTopBox from "components/newsTopBox";
import topbar from "components/topbar";
import moment from "moment/moment";

import { Swiper, Slide } from "vue-swiper-component";
import { serialize } from "utils/index";
// import { mgop } from "@aligov/jssdk-mgop";

export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
      coopType:null,
      name:null,
      gender:null,
      mobile:null,
      idCard:null,
      nowLive:null,
      reason:null,
      policeStation:null,
      trainingPosts:null,
      trainingContent:null,
      coopId:null,
      userId:null,
    };
  },
  components: {
    noMoreData,
    topbar,
    Swiper,
    Slide,
    newsTopBox,
  },
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
      changeGender(e){
          this.gender=e
      },
    // 基础信息埋点配置
    SetZwaplus() {
      ;(function(w, d, s, q, i) {
        w[q] = w[q] || []
        var f = d.getElementsByTagName(s)[0]
        var j = d.createElement(s)
        j.async = true
        j.id = 'beacon-aplus'
        j.src = 'https://d.alicdn.com/alilog/mlog/aplus.js?id=202951085'
        f.parentNode.insertBefore(j, f)
      })(window, document, 'script', 'aplus_queue')
      aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['aplus-rhost-v', 'alog.zjzwfw.gov.cn']
      })
      aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['aplus-rhost-g', 'alog.zjzwfw.gov.cn']
      })
      // 这个会落到 app_key 字段上
      aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['appId', '60506758']
      })
      // 单页应用 或 “单个页面”需异步补充 PV 日志参数还需进行如下埋点：
      aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['aplus-waiting', 'MAN']
      })
      // 单页应用路由切换后 或 在异步获取到 pv 日志所需的参数后再执行 sendPV：
      aplus_queue.push({
        action: 'aplus.sendPV',
        arguments: [
          {
            is_auto: false
          },
          {
            miniAppId: '2001833260',
            miniAppName: '智慧心理'
          }
        ]
      })
    },
    todemo() {
      this.$router.push(`/demo`);
    },
    to(n) {
      this.$router.push(`/${n}`);
    },
    save(){
      if(this.coopId){
        this.commitScaleUserCoopAgain()
      }else{
        this.commitScaleUserCoop()
      }
    },
    async commitScaleUserCoop() {
      // mgop({
      //   api: "mgop.itnbear.scale.commitScaleUserCoop", // 必须
      //   host: "https://mapi.zjzwfw.gov.cn/",
      //   dataType: "JSON",
      //   data:  {
      //       userId: this.userId,
      //       coopType: this.coopType,
      //       name:this.name,
      //       gender:this.gender,
      //       mobile:this.mobile,
      //       idCard:this.idCard?this.idCard:'',
      //       nowLive:this.nowLive?this.nowLive:'',
      //       reason:this.reason?this.reason:'',
      //       policeStation:this.policeStation?this.policeStation:'',
      //       trainingPosts:this.trainingPosts?this.trainingPosts:'',
      //       trainingContent:this.trainingContent?this.trainingContent:'',
      //     },
      //   type: "GET",
      //   appKey: "2201079w+2001833260+slglhh", // 必须
      //   onSuccess: (data) => {
      //     alert('提交成功')
      //     history.back()
      //   },
      //   onFail: (err) => {
      //     console.log(err, "err");
      //   },
      // });
        let data = await getSources(
          "/bear-scale/api/scaleUserCoop/commitScaleUserCoop",
          {
            userId: this.userId,
            coopType: this.coopType,
            name:this.name,
            gender:this.gender,
            mobile:this.mobile,
            idCard:this.idCard?this.idCard:'',
            nowLive:this.nowLive?this.nowLive:'',
            reason:this.reason?this.reason:'',
            policeStation:this.policeStation?this.policeStation:'',
            trainingPosts:this.trainingPosts?this.trainingPosts:'',
            trainingContent:this.trainingContent?this.trainingContent:'',
          }
        );
        if (data.status === 0) {
          alert('提交成功')
          history.back()
        } else {
          alert(data.msg);
        }
    },
    async commitScaleUserCoopAgain() {
      // mgop({
      //   api: "mgop.itnbear.scale.commitScaleUserCoop", // 必须
      //   host: "https://mapi.zjzwfw.gov.cn/",
      //   dataType: "JSON",
      //   data:  {
      //       userId: this.userId,
      //       coopId:this.coopId,
      //       coopType: this.coopType,
      //       name:this.name,
      //       gender:this.gender,
      //       mobile:this.mobile,
      //       idCard:this.idCard?this.idCard:'',
      //       nowLive:this.nowLive?this.nowLive:'',
      //       reason:this.reason?this.reason:'',
      //       policeStation:this.policeStation?this.policeStation:'',
      //       trainingPosts:this.trainingPosts?this.trainingPosts:'',
      //       trainingContent:this.trainingContent?this.trainingContent:'',
      //     },
      //   type: "GET",
      //   appKey: "2201079w+2001833260+slglhh", // 必须
      //   onSuccess: (data) => {
      //     alert('提交成功')
      //     history.back()
      //   },
      //   onFail: (err) => {
      //     console.log(err, "err");
      //   },
      // });
        let data = await getSources(
          "/bear-scale/api/scaleUserCoop/commitScaleUserCoopAgain",
          {
            userId: this.userId,
            coopId:this.coopId,
            coopType: this.coopType,
            name:this.name,
            gender:this.gender,
            mobile:this.mobile,
            idCard:this.idCard?this.idCard:'',
            nowLive:this.nowLive?this.nowLive:'',
            reason:this.reason?this.reason:'',
            policeStation:this.policeStation?this.policeStation:'',
            trainingPosts:this.trainingPosts?this.trainingPosts:'',
            trainingContent:this.trainingContent?this.trainingContent:'',
          }
        );
        if (data.status === 0) {
          alert('提交成功')
          history.back()
        } else {
          alert(data.msg);
        }
    },
    async getScaleUserCoop() {
      // mgop({
      //   api: "mgop.itnbear.scale.getScaleUserCoop", // 必须
      //   host: "https://mapi.zjzwfw.gov.cn/",
      //   dataType: "JSON",
      //   data: { userId: this.userId,coopType: this.coopType },
      //   type: "GET",
      //   appKey: "2201079w+2001833260+slglhh", // 必须
      //   onSuccess: (data) => {
      //     console.log("data", data);

      //     if(!data.data.scaleUserCoop){
      //       return
      //     }
      //     let scaleUserCoop = data.data.scaleUserCoop

      //     this.coopId = scaleUserCoop.coopId?scaleUserCoop.coopId:'',
      //     this.name=scaleUserCoop.name?scaleUserCoop.name:'',
      //     this.gender=scaleUserCoop.gender==null?'':scaleUserCoop.gender,
      //     this.mobile=scaleUserCoop.mobile?scaleUserCoop.mobile:'',
      //     this.idCard=scaleUserCoop.idCard?scaleUserCoop.idCard:'',
      //     this.nowLive=scaleUserCoop.nowLive?scaleUserCoop.nowLive:'',
      //     this.reason=scaleUserCoop.reason?scaleUserCoop.reason:'',
      //     this.policeStation=scaleUserCoop.policeStation?scaleUserCoop.policeStation:'',
      //     this.trainingPosts=scaleUserCoop.trainingPosts?scaleUserCoop.trainingPosts:'',
      //     this.trainingContent=scaleUserCoop.trainingContent?scaleUserCoop.trainingContent:''
      //   },
      //   onFail: (err) => {
      //     console.log(err, "err");
      //   },
      // });
        let data = await getSources(
          "/bear-scale/api/scaleUserCoop/getScaleUserCoop",
          { userId: this.userId,coopType: this.coopType}
        );
        if (data.status === 0) {
          if(!data.scaleUserCoop){
            return
          }
          let scaleUserCoop = data.scaleUserCoop

          this.coopId = scaleUserCoop.coopId?scaleUserCoop.coopId:'',
          this.name=scaleUserCoop.name?scaleUserCoop.name:'',
          this.gender=scaleUserCoop.gender==null?'':scaleUserCoop.gender,
          this.mobile=scaleUserCoop.mobile?scaleUserCoop.mobile:'',
          this.idCard=scaleUserCoop.idCard?scaleUserCoop.idCard:'',
          this.nowLive=scaleUserCoop.nowLive?scaleUserCoop.nowLive:'',
          this.reason=scaleUserCoop.reason?scaleUserCoop.reason:'',
          this.policeStation=scaleUserCoop.policeStation?scaleUserCoop.policeStation:'',
          this.trainingPosts=scaleUserCoop.trainingPosts?scaleUserCoop.trainingPosts:'',
          this.trainingContent=scaleUserCoop.trainingContent?scaleUserCoop.trainingContent:''
        } else {
          alert(data.msg);
        }
    },
  },
  destroyed() {},
  mounted() {
    this.userId = localStorage.getItem('userId');
    this.coopType=this.$route.query.type;
    this.SetZwaplus();
    this.getScaleUserCoop();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/help.vue?0206fa87